import type { ReactNode } from "react";
import { Typography } from "@mui/material";
import Paper from "@components/Paper/Paper";
import PaperItem from "@components/Paper/PaperItem";

export interface DryBulkKeyValueItem {
  label: string;
  value: ReactNode | null | undefined;
}

interface DryBulkKeyValueGridProps {
  testId: string;
  title?: ReactNode;
  items: DryBulkKeyValueItem[];
}

const isEmpty = (value: ReactNode | null | undefined) =>
  value === null || value === undefined || value === "";

/** Read-only label / value pairs in two columns, laid out like liquid's FirstRequestDetails (DBVN-0021, R-C). */
const DryBulkKeyValueGrid: React.FC<DryBulkKeyValueGridProps> = ({ testId, title, items }) => (
  <div data-testid={testId}>
    <Paper variant="outlined">
      {title && (
        <Typography variant="body2" component="h3" sx={{ marginBottom: 3 }}>
          {title}
        </Typography>
      )}
      <div className="grid grid-cols-1 gap-x-8 md:grid-cols-2">
        {items.map((item, index) => (
          <PaperItem
            key={`${item.label}-${index}`}
            testId={`${testId}-${index}`}
            translate={item.label}
            text={isEmpty(item.value) ? "-" : item.value}
            wrapperStyle="border-b border-[#F1F2F4] pb-3 mb-3 flex gap-4"
            tranStyle="font-normal text-[#646A77]"
            textStyles="font-normal"
          />
        ))}
      </div>
    </Paper>
  </div>
);

export default DryBulkKeyValueGrid;
